import { injectable } from './decorators';

@injectable('CACHE_PROVIDER')
export class CacheProvider {
  constructor (store, namespace, defaultState) {
    this.namespace = namespace;
    this.keys = Object.keys(defaultState);
    this.defaultState = Object.assign({}, defaultState);
  }

  /**
   * Caches the state object
   * @param state
   */
  save (state) {
    // Saves only the keys we're interested in to localstorage; uses defaults if undefined
    const data = Object.keys(state).reduce((out, key) => {
      if (this.keys.includes(key)) {
        out[key] = state.hasOwnProperty(key) ? state[key] : this.defaultState[key];
      }
      return out;
    }, this.defaultState);
    localStorage.setItem(this.namespace, JSON.stringify(data));
  }

  /**
   * Attempts to read the state from the cache. Overwrites the keys of the old state with the saved state.
   * @param oldState
   */
  restore (oldState = {}) {
    const data = localStorage.getItem(this.namespace);
    const newState = data ? JSON.parse(data) : this.defaultState;
    Object.assign(oldState, newState);
    return oldState;
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/core/CacheProvider.js